var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_27_3",
    "data-name": "Component 27 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hotel_5_",
    "data-name": "hotel (5)",
    transform: "translate(-43.288 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M65.162,18.836V3.825H63.6V1.286H59.874V0H58.7V1.286H54.977V3.825H53.414V18.836H51.288v1.172h16V18.836ZM56.149,2.458h6.278V3.825H56.149Zm5.5,16.378H59.874V14.552h1.771Zm-2.943,0H56.931V14.552H58.7Zm4.116,0V13.38H55.759v5.457H54.586V5h9.4V18.836Z",
    transform: "translate(0)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M165.688,158.205h1.172v1.172h-1.172Z",
    transform: "translate(-109.929 -152.022)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M316.312,158.205h1.172v1.172h-1.172Z",
    transform: "translate(-254.667 -152.022)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M241,158.205h1.172v1.172H241Z",
    transform: "translate(-182.298 -152.022)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M165.688,218.541h1.172v1.172h-1.172Z",
    transform: "translate(-109.929 -210.001)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M316.312,218.541h1.172v1.172h-1.172Z",
    transform: "translate(-254.667 -210.001)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M241,218.541h1.172v1.172H241Z",
    transform: "translate(-182.298 -210.001)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M165.688,278.878h1.172v1.172h-1.172Z",
    transform: "translate(-109.929 -267.98)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M316.312,278.878h1.172v1.172h-1.172Z",
    transform: "translate(-254.667 -267.98)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M241,278.878h1.172v1.172H241Z",
    transform: "translate(-182.298 -267.98)",
    fill: "#041543"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBuildingIcon);
export default __webpack_public_path__ + "static/media/top-building-icon.d8d311fb8362a16354523581e0d7b3d6.svg";
export { ForwardRef as ReactComponent };